import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { colors, breakpoints } from '@nextinq/ui-toolkit';
import { sizes } from '../themes/sizes';
import { SemanticSIZES } from 'semantic-ui-react';

const Wrapper = styled.div<{ padding: string; bgColor: string; borderColor: string }>`
  display: grid;
  padding: ${(p) => p.padding};
  background-color: ${(p) => p.bgColor};
  border: 1px solid ${(p) => p.borderColor};
  border-radius: ${sizes.margins.normal};
  min-width: 280px;
  @media ${breakpoints.max.smallPhone} {
    padding: ${sizes.margins.normal};
  }
`;

export interface SegmentProps {
  children?: ReactNode;
  padding?: SemanticSIZES;
  primary?: boolean;
}

export function Segment(props: SegmentProps) {
  const rawPadding = props.padding || 'huge';
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  const padding = sizes.margins[rawPadding];
  const bgColor = props.primary ? colors.background.primary : colors.neutral.white;
  const borderColor = props.primary ? colors.base.primary : colors.grey.greyLightest;
  return (
    <Wrapper bgColor={bgColor} borderColor={borderColor} padding={padding} className="ui form">
      {props.children}
    </Wrapper>
  );
}
